var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_307",
    "data-name": "Group 307",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120.84,
    height: 94.409,
    viewBox: "0 0 120.84 94.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 120.84,
    height: 94.409,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M8.591,226.558a8,8,0,0,1-3.334-.706A8.61,8.61,0,0,1,2.516,223.9a9.365,9.365,0,0,1,0-12.819,8.663,8.663,0,0,1,2.741-1.948,8,8,0,0,1,3.334-.706,7.988,7.988,0,0,1,3.908.98,8.809,8.809,0,0,1,2.96,2.616l-3.347,1.8a4.93,4.93,0,0,0-1.561-1.2,4.5,4.5,0,0,0-3.84-.037,4.895,4.895,0,0,0-1.549,1.143,5.378,5.378,0,0,0-1.043,1.692,5.893,5.893,0,0,0,0,4.134,5.364,5.364,0,0,0,1.043,1.692,4.972,4.972,0,0,0,1.549,1.149,4.436,4.436,0,0,0,3.84-.038,4.912,4.912,0,0,0,1.561-1.218l3.347,1.823a8.925,8.925,0,0,1-2.96,2.61,7.947,7.947,0,0,1-3.908.987",
    transform: "translate(0 -148.682)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M64.631,210.692h4.221L75.2,228.175H71.225l-1-2.747H63.258l-1,2.747H58.288Zm0,10.989h4.221l-2.123-5.794Z",
    transform: "translate(-41.58 -150.298)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M124.245,228.175V210.692h7.118a4.811,4.811,0,0,1,2.6.724,5.294,5.294,0,0,1,1.842,1.942,5.4,5.4,0,0,1,.68,2.679,5.741,5.741,0,0,1-.375,2.092,5.275,5.275,0,0,1-1.068,1.711,5.4,5.4,0,0,1-1.63,1.193l4.146,7.143h-4.321l-3.946-6.794h-1.3v6.794Zm3.746-10.54h2.922a1.688,1.688,0,0,0,.911-.256,1.956,1.956,0,0,0,.662-.681,1.881,1.881,0,0,0,0-1.873,1.958,1.958,0,0,0-.662-.681,1.7,1.7,0,0,0-.911-.256h-2.922Z",
    transform: "translate(-88.631 -150.298)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M184.513,228.175l-4.471-17.483h3.871l2.7,10.59,2.7-10.59h3.447l2.7,10.59,2.7-10.59h3.871l-4.446,17.483h-4.221l-2.323-9.066-2.3,9.066Z",
    transform: "translate(-128.434 -150.298)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M262.622,210.692h4.221l6.343,17.483h-3.971l-1-2.747h-6.968l-1,2.747h-3.971Zm0,10.989h4.221l-2.123-5.794Z",
    transform: "translate(-182.818 -150.298)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M324.523,226.558a8.543,8.543,0,0,1-2.822-.468,7.1,7.1,0,0,1-2.36-1.349,5.073,5.073,0,0,1-1.461-2.1l3.521-1.3a1.585,1.585,0,0,0,.555.7,3.584,3.584,0,0,0,1.093.556,4.674,4.674,0,0,0,1.474.219,4.463,4.463,0,0,0,1.411-.219,2.845,2.845,0,0,0,1.074-.606,1.2,1.2,0,0,0,.412-.9,1.065,1.065,0,0,0-.431-.868,3.322,3.322,0,0,0-1.1-.549,8.944,8.944,0,0,0-1.368-.306,13.945,13.945,0,0,1-3.4-.905,5.749,5.749,0,0,1-2.373-1.742,4.444,4.444,0,0,1-.868-2.822,4.639,4.639,0,0,1,.924-2.866,6.168,6.168,0,0,1,2.441-1.917,7.856,7.856,0,0,1,3.278-.687,8.6,8.6,0,0,1,2.828.468,7.027,7.027,0,0,1,2.366,1.355,5,5,0,0,1,1.449,2.123l-3.521,1.274a1.547,1.547,0,0,0-.556-.693,3.588,3.588,0,0,0-1.093-.543,4.816,4.816,0,0,0-1.474-.212,4.066,4.066,0,0,0-1.386.212,3.042,3.042,0,0,0-1.086.612,1.162,1.162,0,0,0-.425.875,1.23,1.23,0,0,0,.4,1.005,2.4,2.4,0,0,0,1.055.468q.655.138,1.442.25a12.5,12.5,0,0,1,3.309.937,6.42,6.42,0,0,1,2.423,1.8,4.2,4.2,0,0,1,.911,2.735,4.658,4.658,0,0,1-.918,2.866,6.129,6.129,0,0,1-2.429,1.916,7.873,7.873,0,0,1-3.3.687",
    transform: "translate(-226.761 -148.682)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M383.756,210.692H387.5v17.483h-3.747v-7.492h-6.194v7.492h-3.746V210.692h3.746v6.244h6.194Z",
    transform: "translate(-266.663 -150.298)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M154.117,280.566h2.807l5.085,13.986h-2.587l-.9-2.478h-5.994l-.9,2.478h-2.588Zm-.7,9.071h4.206l-2.108-5.765Z",
    transform: "translate(-106.32 -200.143)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M201.564,294.551V280.565h4.995a3.857,3.857,0,0,1,2.063.569,4.158,4.158,0,0,1,1.463,1.529,4.221,4.221,0,0,1,.54,2.108,4.167,4.167,0,0,1-.555,2.133,4.24,4.24,0,0,1-1.484,1.519,3.837,3.837,0,0,1-2.028.564H204v5.565Zm2.438-8h2.3a1.8,1.8,0,0,0,.949-.26,1.937,1.937,0,0,0,.684-.7,1.914,1.914,0,0,0,.255-.979,1.936,1.936,0,0,0-.939-1.688,1.8,1.8,0,0,0-.949-.26H204Z",
    transform: "translate(-143.787 -200.142)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M240.911,294.551V280.565h4.995a3.858,3.858,0,0,1,2.063.569,4.159,4.159,0,0,1,1.463,1.529,4.22,4.22,0,0,1,.54,2.108,4.167,4.167,0,0,1-.555,2.133,4.24,4.24,0,0,1-1.484,1.519,3.837,3.837,0,0,1-2.028.564h-2.557v5.565Zm2.438-8h2.3a1.8,1.8,0,0,0,.949-.26,1.936,1.936,0,0,0,.684-.7,1.914,1.914,0,0,0,.255-.979,1.935,1.935,0,0,0-.939-1.688,1.8,1.8,0,0,0-.949-.26h-2.3Z",
    transform: "translate(-171.855 -200.142)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M120.867,26.656a4.03,4.03,0,0,1-1.515-3.148A3.516,3.516,0,0,1,122.864,20h2.8a3.32,3.32,0,0,1,2.257.886l1.314-1.972a9.518,9.518,0,0,1,7.958-4.228h15.324a9.519,9.519,0,0,1,7.959,4.23l1.312,1.969A3.319,3.319,0,0,1,164.041,20h2.8a3.516,3.516,0,0,1,3.512,3.512,4.031,4.031,0,0,1-1.514,3.147,9.354,9.354,0,0,1,2.271,3.389,26.493,26.493,0,1,0-52.51,0,9.352,9.352,0,0,1,2.271-3.388",
    transform: "translate(-84.432 0.001)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M191.149,167.465c-.051-.035-.1-.068-.151-.1l-1.8-1.349a1,1,0,0,0-.6-.2H167.326a.984.984,0,0,0-.59.2l-1.822,1.362c-.045.034-.092.064-.138.1v.292a26.527,26.527,0,0,0,26.373,0Z",
    transform: "translate(-117.544 -118.281)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M143.985,73.535a10.322,10.322,0,0,0,3.346.556h17.661a10.322,10.322,0,0,0,3.346-.556l9.772-3.338a8.083,8.083,0,0,0-4.166-1.657l-4.071-6.108a7.254,7.254,0,0,0-6.05-3.206H148.5a7.254,7.254,0,0,0-6.05,3.206l-4.071,6.108a8.084,8.084,0,0,0-4.166,1.656Z",
    transform: "translate(-95.741 -42.249)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M171.788,99.811,161.574,103.3a11.19,11.19,0,0,1-3.624.6H140.29a11.191,11.191,0,0,1-3.624-.6l-10.214-3.489a8.42,8.42,0,0,0-2.109,6.068v11.315a1.572,1.572,0,0,0,1.572,1.572h7.841a1.558,1.558,0,0,0,.942-.315l1.814-1.356a3.273,3.273,0,0,1,1.972-.66h21.271a3.283,3.283,0,0,1,1.975.66l1.81,1.356a1.565,1.565,0,0,0,.942.315h7.845a1.574,1.574,0,0,0,1.572-1.572V105.879a8.42,8.42,0,0,0-2.109-6.068",
    transform: "translate(-88.7 -71.201)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M129.3,171.8a.924.924,0,0,0,.924.924h6.027a.924.924,0,0,0,.924-.924v-1.637H129.3Z",
    transform: "translate(-92.239 -121.386)",
    fill: "#27b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M264.782,171.8a.924.924,0,0,0,.924.924h6.027a.924.924,0,0,0,.924-.924v-1.637h-7.875Z",
    transform: "translate(-188.883 -121.386)",
    fill: "#27b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M185.56,27.13l.646,1.747,1.747.647a.071.071,0,0,1,0,.133l-1.747.646-.646,1.747a.071.071,0,0,1-.133,0l-.647-1.747-1.747-.646a.071.071,0,0,1,0-.133l1.747-.647.647-1.747a.071.071,0,0,1,.133,0",
    transform: "translate(-130.535 -19.32)",
    fill: "#27b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M158.332,70.45l2.771-4.158A5.852,5.852,0,0,1,166,63.7h14.731a5.851,5.851,0,0,1,4.9,2.59L188.4,70.45Z",
    transform: "translate(-112.947 -45.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M138.2,117.916l-5.543-.263a1.063,1.063,0,0,1-1.012-1.061V115.1a1.507,1.507,0,0,1,1.778-1.483l6.836,1.249a.666.666,0,0,1,.417,1.048l-.923,1.258a1.818,1.818,0,0,1-1.552.74",
    transform: "translate(-93.912 -81.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M141,154.306h-3.8a.622.622,0,0,1-.559-.9l.586-1.2a.622.622,0,0,1,.559-.349h3.775a.622.622,0,0,1,.564.886l-.56,1.2a.622.622,0,0,1-.563.358",
    transform: "translate(-97.427 -108.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M166.123,127.145a.656.656,0,0,1-.675-.8l.469-1.761a4.713,4.713,0,0,1,4.274-3.444c.11-.006.22-.009.333-.009H186.3c.11,0,.223,0,.332.009a4.72,4.72,0,0,1,4.274,3.444l.466,1.761a.656.656,0,0,1-.672.8Z",
    transform: "translate(-118.009 -86.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M260.44,117.916l5.543-.263A1.063,1.063,0,0,0,267,116.592V115.1a1.507,1.507,0,0,0-1.778-1.483l-6.836,1.249a.666.666,0,0,0-.417,1.048l.923,1.258a1.818,1.818,0,0,0,1.552.74",
    transform: "translate(-183.928 -81.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M266.487,154.306h3.8a.622.622,0,0,0,.559-.9l-.586-1.2a.622.622,0,0,0-.559-.349h-3.775a.622.622,0,0,0-.564.886l.56,1.2a.622.622,0,0,0,.563.358",
    transform: "translate(-189.256 -108.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M167.435,88.869l.532,1.438,1.438.532a.058.058,0,0,1,0,.109l-1.438.532-.532,1.438a.058.058,0,0,1-.109,0l-.532-1.438-1.438-.532a.058.058,0,0,1,0-.109l1.438-.532.532-1.438a.058.058,0,0,1,.109,0",
    transform: "translate(-117.93 -63.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M134.668,80.726h-3.1a1.746,1.746,0,0,1-1.746-1.745,1.218,1.218,0,0,1,1.219-1.219h2.8a1.043,1.043,0,0,1,1.043,1.043v1.708a.214.214,0,0,1-.214.214",
    transform: "translate(-92.61 -55.472)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M274.3,80.726h3.1a1.746,1.746,0,0,0,1.746-1.745,1.218,1.218,0,0,0-1.219-1.219h-2.8a1.043,1.043,0,0,0-1.043,1.043v1.708a.214.214,0,0,0,.214.214",
    transform: "translate(-195.521 -55.472)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M220.75,13.125l1.027,2.775,2.775,1.027a.112.112,0,0,1,0,.211l-2.775,1.027L220.75,20.94a.112.112,0,0,1-.211,0l-1.027-2.775-2.775-1.027a.113.113,0,0,1,0-.211l2.775-1.027,1.027-2.775a.113.113,0,0,1,.211,0",
    transform: "translate(-154.558 -9.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M263.316,35.686l.718,1.941,1.941.718a.079.079,0,0,1,0,.148l-1.941.718-.718,1.942a.079.079,0,0,1-.148,0l-.718-1.942-1.941-.718a.079.079,0,0,1,0-.148l1.941-.718.718-1.941a.079.079,0,0,1,.148,0",
    transform: "translate(-185.798 -25.42)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeLogo);
export default __webpack_public_path__ + "static/media/theme-logo.c380ad48285b452ff2eb3ea69cf29d1e.svg";
export { ForwardRef as ReactComponent };